import React, {Component } from 'react';

import { createNewHeaders, updateHeaders,executePost, executeGet } from '../../functions/Kubuku';
import { ADD_BANNER, LIST_CONTENT, UPDATE_POSISI, CUD_ETALASE, DELETE_CONTENT } from '../../api';

import QRCode from "react-qr-code";
import ModalPilihBuku from '../../components/ModalPilihBuku';
import ModalLoading from "../../components/ModalLoading";
import ModalPopup from "../../components/ModalPopup";
import ModalQR from "../../components/ModalQR"

import {
    useParams,
    useNavigate
} from "react-router-dom";

class Etalase extends Component {

    constructor(props) {
        super(props)
        this.state = {
            param: this.props.params,
            currentPage: 1,
            showMain: false,
            showModal: false,
            isLoading: false,
            showLoading: false,
            isModal: false,
            isError: false,
            isQR: false,
            judul: '',
            deskripsi: '',
            data: '',
            banner: '',
            msg: '',
            id: '',
            kode_beranda: '',
            kode_section:'',
            status: 0,
            modalEdit: false,
            dataKonten:'',
            posisi:10,
            flagEtalase: true,
            flagKonten: false,
            chgImage: false,
            imgBanner: null
        }
        this.imgRef = React.createRef();
    }
    
    componentDidMount() {
        console.log("setting etalase = " + this.state.param.id);
        //alert("yes");
        this.getEtalase();
    }

    scriptLoaded() {
        console.log("script load");
        // window.A.sort();
    }
    actFile = () => {
        document.getElementById('formFile').click();
    }
    actChangeDesktop = (e) => {

        const [file] = e.target.files;
        if (file.type=='image/png') {
            
            document.getElementById('imgDesktop').src = window.URL.createObjectURL(file)
            this.setState({
                chgImage: true,
                imgBanner: e.target.files[0]
            })
        } else {
            this.setState({isError: true, msg: 'Anda tidak bisa menggunakan file ini. File harus image .png' });
        }
    }
    onImgLoadDesktop = async ({ target: img }) => {
        const { offsetHeight, offsetWidth } = img;
        
        if (this.state.chgImage) {
            if (Math.floor(offsetHeight*(1000/750))!=180 || Math.floor(offsetWidth*(1000/750)) != 1000) {
                this.setState({isError: true, msg: 'Ukuran file tidak sesuai' });
                document.getElementById('imgDesktop').src = "";
            } else {
                let formData = new FormData();
                formData.append("img_banner", this.state.imgBanner);
                formData.append("kode_section", this.state.param.id);
                formData.append("mobile", "0");
                const json = await executePost(ADD_BANNER, formData);
                if (json.code== 200) {
                    this.setState({isModal: true, msg: json.msg });
                    this.getEtalase();
                } else {
                    this.setState({isError: true, msg: json.msg });
                }
            }
            
        }
        this.setState({
            chgImage: false
        })
        
    }
    actFileMobile = () => {
        
        document.getElementById('formFileMobile').click();
    }
    actChangeMobile = (e) => {

        const [file] = e.target.files;
        if (file.type=='image/png') {
            
            document.getElementById('imgMobile').src = window.URL.createObjectURL(file)
            this.setState({
                chgImage: true,
                imgBanner: e.target.files[0]
            })
        } else {
            this.setState({isError: true, msg: 'Anda tidak bisa menggunakan file ini. File harus image .png' });
        }
    }
    onImgLoadMobile = async  ({ target: img }) => {
        
        const { offsetHeight, offsetWidth } = img;
        if (this.state.chgImage) {
            if (offsetHeight*2!=200 || offsetWidth*2 != 640) {
                this.setState({isError: true, msg: 'Ukuran file tidak sesuai' });
                document.getElementById('imgMobile').src = "";
            } else {
                let formData = new FormData();
                formData.append("img_banner", this.state.imgBanner);
                formData.append("kode_section", this.state.param.id);
                formData.append("mobile", "1");
                const json = await executePost(ADD_BANNER, formData);
                if (json.code== 200) {
                    this.setState({isModal: true, msg: json.msg });
                    this.getEtalase();
                } else {
                    this.setState({isError: true, msg: json.msg });
                }
            }
            
        }
        this.setState({
            chgImage: false
        })
        
    }
    deleteBanner = async() => {
        let formData = new FormData();
        formData.append("kode_section", this.state.param.id);
        formData.append("mode", "del");
        const json = await executePost(ADD_BANNER, formData);
        if (json.code== 200) {
            this.setState({isModal: true, msg: json.msg });
            this.getEtalase();
        } else {
            this.setState({isError: true, msg: json.msg });
        }
        
    }
    getEtalase = async () => {
        //alert(this.state.param.id);
        try {
            const flagOpen = localStorage.getItem('flagOpen');
            if(flagOpen != "1") {
                createNewHeaders('', ''); 
            } else {
                updateHeaders('', ''); 
            }
            
            const json = await executeGet(LIST_CONTENT + this.state.param.id);
            console.log("get_etalase = " + JSON.stringify(json));
            if (json.code == 200) {
                this.setState({
                    data: json.data,
                    banner: json.banner,
                    showMain: true,
                    id: json.id,
                    kode_beranda: json.kode_beranda,
                    judul: json.judul,
                    deskripsi: json.deskripsi,
                    status: json.aktif
                });
                console.log("total data = " + this.state.data.length);
            } else if (json.code == 404) {
                //masukkan tgl lahir
                // this.setState({ flagData: false, msg: json.msg });
            } else if (json.code == 500 || json.code == 505) {
                window.location.href = window.location.origin + "/login";
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }


    deleteKonten = async (param) => {
        console.log("param del = " + JSON.stringify(param));
        this.setState({ isLoading: true });
        try {
            let formData = new FormData();
            formData.append("id", param.id);
            formData.append("kode_section", this.state.param.id);

            const json = await executePost(DELETE_CONTENT, formData);
            console.log("delete_konten = " + JSON.stringify(json));
            if (json.code == 200) {
                this.setState({ isLoading: false, isModal: true, msg: 'Berhasil Delete Konten' });
                this.getEtalase();
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }

    updateEtalase = async () => {
        // console.log("param update = " + JSON.stringify(param));
        this.setState({ isLoading: true });
        try {
            let formData = new FormData();
            formData.append("id", this.state.id);
            formData.append("kode_beranda", this.state.kode_beranda);
            formData.append("kode", this.state.param.id);
            formData.append("judul", this.state.judul);
            formData.append("aktif", this.state.status);
            formData.append("deskripsi", this.state.deskripsi);
            
            const json = await executePost(CUD_ETALASE, formData);
            console.log("update_etalase = " + JSON.stringify(json));
            if (json.code == 200) {
                this.setState({ isLoading: false, isModal: true, msg: 'Berhasil Update Etalase' });
                this.getEtalase();
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }
    onQR = async (url) => {
        this.setState({ isLoading: false, isQR: true, msg: url });
    }

    onShare = async (url) => {
        const title = document.title;
        const text = "Silahkan buka Link di atas.";
        try {
            await navigator
            .share({
                title,
                url,
                text
            })
            } catch (err) {
                alert(`Couldn't share ${err}`);
            }
    }

    updatePosisi = async() => {
        this.setState({ modalEdit: false });
        try {
            let formData = new FormData();
            formData.append("id", this.state.dataKonten.id);
            formData.append("kode_section", this.state.param.id);
            formData.append("posisi", this.state.posisi);
            
            
            const json = await executePost(UPDATE_POSISI, formData);
            console.log("update_etalase = " + JSON.stringify(json));
            if (json.code == 200) {
                
                this.setState({ dataKonten:json.data, isLoading: false, isModal: true, msg: 'Berhasil Update Posisi' });
                this.getEtalase();
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }
    currencyFormat(num) {
        return 'Rp. ' + parseFloat(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    etalaseMaster() {
        this.setState({flagEtalase:true, flagKonten:false});
    }

    listKonten() {
        this.setState({flagEtalase:false, flagKonten:true});
    }

    render() {
        return (
            <div>
                {
                    this.state.isLoading &&
                    <ModalLoading />
                }
                {
                    this.state.isModal &&
                    <ModalPopup
                        type="success"
                        messages={this.state.msg}
                        press={() => { this.setState({ isModal: false }) }}
                    />
                }
                {
                    this.state.isQR &&
                    <ModalQR
                        type="success"
                        messages={this.state.msg}
                        press={() => { this.setState({ isQR: false }) }}
                    />
                }
                {
                    this.state.isError &&
                    <ModalPopup
                        type="error"
                        messages={this.state.msg}
                        press={() => { this.setState({ isError: false }) }}
                    />
                }
                {
                    this.state.showModal &&
                    <ModalPilihBuku
                        kodeEtalase={this.state.param.id}
                        close={() => {
                            this.setState({ showModal: false });
                            this.getEtalase();
                        }}
                    />
                }
                {
                    this.state.modalEdit &&
                    <div>
                        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="relative w-[90%] md:w-[40%] h-[35%] my-6 mx-auto">
                                {/*content*/}
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none h-[100%]">
                                    {/*header*/}
                                    <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                                        <div className="flex w-full">
                                            <h3 className="text-xl font-semibold dark:text-black w-[50%]">
                                                Set Posisi Urutan Buku
                                            </h3>
                                            <div className="w-[50%] flex justify-end items-end" onClick={() => this.setState({ modalEdit: false })}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" onClick={() => this.setState({ modalEdit: false })}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="relative p-6 flex-auto">
                                        <form>
                                            <div className="mb-2">
                                                <label for="kuota" className="block mb-2 text-sm font-medium text-grayWalangDark dark:text-gray-800">Jumlah Kuota :</label>
                                                <input type="kuota" id="kuota" value={this.state.posisi} onChange={event => this.setState({ posisi: event.target.value })} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="0" required />
                                            </div>
                                        </form>
                                        <div onClick={this.updatePosisi}  className="flex justify-end items-end mt-3">
                                            <button type="button" className="w-[30%] bg-greenWalang font-medium rounded-full text-sm px-2 py-1.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center hover:shadow-[0_8px_25px_-8px_#8e8e8e] hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                                <div className="text-white text-[18px] py-1">
                                                    Kirim
                                                </div>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>
                }
                {
                    this.state.showMain &&
                    <div className="dark:bg-white border rounded-2xl md:p-[30px] p-[15px] mb-20">
                        <div className="text-[24px] font-semibold dark:text-black">Pengaturan Konten</div>
                        <div className="text-[16px] font-semibold dark:text-grayWalangDark pb-3">{this.state.judul}</div>
                        <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
                                <li className="mr-2">
                                    <a onClick={() => this.etalaseMaster()} className={this.state.flagEtalase ? "cursor-pointer inline-block p-4 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Data Etalase</a>
                                </li>
                                <li className="mr-2">
                                    <a onClick={() => this.listKonten()} className={this.state.flagKonten ? "cursor-pointer inline-block p-4 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>List Konten</a>
                                </li>
                                
                            </ul>
                        {this.state.flagEtalase && 
                            <div className="relative p-1 flex-auto">
                                <form>
                                    <div className="mb-6">
                                        <label for="judul" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Nama Etalase</label>
                                        <input type="text" id="judul" value={this.state.judul} onChange={event => this.setState({ judul: event.target.value })} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Nama Outlet" required />
                                    </div>
                                    <div className="mb-6">
                                        <label for="deskripsi" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Deskripsi Etalase</label>
                                        <input type="text" id="deskripsi" value={this.state.deskripsi} onChange={event => this.setState({ deskripsi: event.target.value })} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Deskripsi Outlet" required />
                                    </div>
                                    <div className="mb-6">
                                        <label for="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Status Etalase</label>
                                        <select value={this.state.status} onChange={event => this.setState({ status: event.target.value }) } className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light pr-10" placeholder="Single" required>
                                            <option value="0">Tidak Aktif</option>
                                            <option value="1">Aktif</option>
                                        </select>
                                    </div>
                        
                                    <div className="flex items-end">
                                        {this.state.banner.length>=1 ?
                                        <>
                                            <div className='flex flex-col'>
                                                
                                                <div className='pb-2 pt-2'>
                                                <input className="hidden" onChange={this.actChangeDesktop} type="file" id="formFile"/>
                                                <button onClick={this.actFile} type="button" className="w-[130px] bg-greenWalang rounded-full text-sm px-1 py-1 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                                    <div className="text-[#ffffff] text-md">
                                                        Ganti Banner
                                                    </div>
                                                </button>
                                                Banner Web [File .png, ukuran 1000x250 pixel]
                                                </div>
                                                <div className='pb-2'><img className='max-w-[750px]' id="imgDesktop" onLoad={this.onImgLoadDesktop} src={this.state.banner[0].url_image}></img></div>
                                            </div>
                                        </>:<>
                                        <div className='flex flex-col'>
                                                <div className='pb-2 pt-2'>
                                                <input className="hidden" onChange={this.actChangeDesktop} type="file" id="formFile"/>
                                                <button onClick={this.actFile} type="button" className="w-[130px] bg-greenWalang rounded-full text-sm px-1 py-1 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                                    <div className="text-[#ffffff] text-md">
                                                        Upload Banner
                                                    </div>
                                                </button>
                                                Banner Web [File .png, ukuran 1000x250 pixel]
                                                </div>
                                                <div className='pb-2'><img className='max-w-[750px]' id="imgDesktop" onLoad={this.onImgLoadDesktop}></img></div>
                                            </div>
                                        </>}
                                    </div>
                                    <div className="flex  items-end">
                                        {this.state.banner.length>=1 ?
                                        <>
                                            <div className='flex flex-col'>
                                                <div className='pt-2 pb-2'>
                                                <input className="hidden" type="file" onChange={this.actChangeMobile} id="formFileMobile"/>
                                                <button onClick={this.actFileMobile} type="button" className="w-[130px] bg-greenWalang rounded-full text-sm px-1 py-1 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                                    <div className="text-[#ffffff] text-md">
                                                        Ganti Banner
                                                    </div>
                                                </button>Banner Handphone [File .png, ukuran 640x300 pixel]
                                                </div>
                                                <div className='pb-2'><img  ref={this.imgRef} onLoad={this.onImgLoadMobile} id="imgMobile" className="max-w-[320px]" src={this.state.banner[0].url_image_mobile}></img></div>
                                            </div>
                                        </>:<>
                                            <div className='flex flex-col'>
                                                <div className='pb-2 pt-2'>
                                                    <input className="hidden" type="file" onChange={this.actChangeMobile} id="formFileMobile"/>
                                                    <button onClick={this.actFileMobile} type="button" className="w-[130px] bg-greenWalang rounded-full text-sm px-1 py-1 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                                        <div className="text-[#ffffff] text-md">
                                                            Upload Banner
                                                        </div>
                                                    </button>
                                                    Banner Handphone [File .png, ukuran 640x300 pixel]
                                                </div>
                                                <div className='pb-2'><img onLoad={this.onImgLoadMobile} id="imgMobile" className="max-w-[320px]"></img></div>
                                            </div>
                                        </>}
                                    </div>
                                    <div className="flex mt-2 items-end">
                                        {this.state.banner.length>=1 &&
                                        <>
                                            <div className='flex flex-col'>
                                                <button onClick={this.deleteBanner} type="button" className="w-[130px] bg-[#FF0000] rounded-full text-sm px-1 py-1 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                                    <div className="text-[#ffffff] text-md">
                                                        Hapus Banner
                                                    </div>
                                                </button>
                                                
                                            </div>
                                        </>
                                        }
                                    </div>
                                </form>
                                <div className="flex justify-end items-end">
                                    <button onClick={this.updateEtalase} type="button" className="md:w-[20%] w-[50%] bg-greenWalang rounded-full text-sm px-1 py-1 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                        <div className="text-[#ffffff] text-md py-2">
                                            Update Etalase
                                        </div>
                                    </button>
                                </div>

                            </div>
                        }
                        { this.state.flagKonten && 
                            <div className="pt-8">
                                {/* <button onClick={() => { this.setState({ showModal: true }) }} type="button" className="bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2">
                                    <div className="text-[#ffffff] pr-4">
                                        Tambah List Etalase
                                    </div>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 17V7" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                        <path d="M7 12L17 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>
                                </button> */}
                                <div>
                                    {this.state.status=="0" &&
                                    <div class="flex p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800" role="alert">
                                    <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                                    <span class="sr-only">Info</span>
                                    <div>
                                      <span class="font-medium">Perhatian</span> Outlet ini belum aktif, sehingga QR dan share belum berfungsi. QR dan Share otomatis akan berfungsi apabila etalase ini diaktifkan.
                                    </div>
                                  </div>
                                    }
                                    <div className="text-[24px] font-semibold dark:text-black mt-4">List Konten</div>
                                    <div className='grid grid-cols-1 gap-x-1 gap-y-1  md:gap-x-2 md:gap-y-2 md:grid-cols-4 md:mx-2 px-4 md:px-0 mt-1 md:space-x-2 mb-4'>
                                        <div className="flex justify-center items-center">
                                            <button onClick={() => { this.setState({ showModal: true }) }} type="button" className="bg-greenWalang font-medium rounded-full text-sm md:px-2 md:py-1 px-4 py-3 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 17V7" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                                    <path d="M7 12L17 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                                </svg>
                                                <div className="text-[#ffffff] pr-4">
                                                    Tambah buku
                                                </div>
                                            </button>
                                        </div>
                                        {this.state.data.length >= 1 && this.state.data.map(item => {
                                            return (
                                                <div className="bg-white relative">
                                                    <center className='h-72 pb-2'>
                                                        <img className='h-full product-img ' src={item.cover} alt="" />
                                                    </center>
                                                    <div className="line-clamp-2 pt-2 font-semibold">{item.judul}</div>
                                                    <div className="line-clamp-1 text-grayWalangDark text-sm pt-2">{item.penulis}</div>
                                                    <div className="line-clamp-1 text-grayWalangDark text-sm pt-2">{item.penerbit}</div>
                                                    <div className="text-lg font-semibold text-greenWalang">{this.currencyFormat(item.harga)}</div>
                                                    <div className="grid grid-cols-4 pt-3 cursor-pointer">
                                                        <div className="cursor-pointer" onClick={() => this.onShare(window.location.origin + '/etalaseDetails/' + item.id)}>
                                                            <div className="items-center flex">
                                                                <svg className="h-6 w-6" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M18.25 9.5C18.25 7.70507 19.7051 6.25 21.5 6.25C23.2949 6.25 24.75 7.70507 24.75 9.5C24.75 11.2949 23.2949 12.75 21.5 12.75C20.5404 12.75 19.6779 12.3341 19.083 11.6727L16.3657 13.1549L13.3251 14.8923C13.5955 15.3664 13.75 15.9152 13.75 16.5C13.75 16.7963 13.7103 17.0834 13.636 17.3562L19.083 20.3273C19.6779 19.6659 20.5404 19.25 21.5 19.25C23.2949 19.25 24.75 20.7051 24.75 22.5C24.75 24.2949 23.2949 25.75 21.5 25.75C19.7051 25.75 18.25 24.2949 18.25 22.5C18.25 22.2036 18.2897 21.9166 18.364 21.6438L12.917 18.6727C12.3221 19.3341 11.4596 19.75 10.5 19.75C8.70507 19.75 7.25 18.2949 7.25 16.5C7.25 14.7051 8.70507 13.25 10.5 13.25C11.1507 13.25 11.7567 13.4412 12.2649 13.7705L15.6343 11.8451L18.364 10.3562C18.2897 10.0834 18.25 9.79635 18.25 9.5ZM21.5 7.75C20.5335 7.75 19.75 8.5335 19.75 9.5C19.75 10.4665 20.5335 11.25 21.5 11.25C22.4665 11.25 23.25 10.4665 23.25 9.5C23.25 8.5335 22.4665 7.75 21.5 7.75ZM10.5 14.75C9.5335 14.75 8.75 15.5335 8.75 16.5C8.75 17.4665 9.5335 18.25 10.5 18.25C11.4665 18.25 12.25 17.4665 12.25 16.5C12.25 15.5335 11.4665 14.75 10.5 14.75ZM19.75 22.5C19.75 21.5335 20.5335 20.75 21.5 20.75C22.4665 20.75 23.25 21.5335 23.25 22.5C23.25 23.4665 22.4665 24.25 21.5 24.25C20.5335 24.25 19.75 23.4665 19.75 22.5Z" fill="#2BC239" />
                                                                </svg>
                                                            </div>


                                                            <div className="items-center flex">
                                                                <a className="text-black text-sm text-center text-[10px]">Share</a>
                                                            </div>

                                                        </div>

                                                        <div className="cursor-pointer" onClick={() => this.onQR(window.location.origin + '/etalaseDetails/' + item.id)}>
                                                            <div className="items-center flex">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                                                            </svg>
                                                            </div>


                                                            <div className="items-center flex">
                                                                <a className="text-black text-sm text-center text-[10px]">QR</a>
                                                            </div>

                                                        </div>

                                                        <div  onClick={() => { this.setState({ modalEdit: true, posisi:item.posisi, dataKonten: item })}}>
                                                            <div className="items-center flex">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                                                            </svg>

                                                            </div>

                                                            <div className="items-center flex">
                                                                <a className="text-black text-sm text-center text-[10px]">Posisi</a>
                                                            </div>
                                                        </div>

                                                        <div className="cursor-pointer">
                                                            <div className="items-center flex" onClick={() => { this.deleteKonten(item) }}>
                                                                <svg className='w-6 h-6' viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M22.5172 16.7795L23.26 16.8829L22.5172 16.7795ZM22.2549 18.6645L22.9977 18.7679L22.2549 18.6645ZM9.74514 18.6645L10.488 18.5611L9.74514 18.6645ZM9.4828 16.7795L8.73996 16.8829L9.4828 16.7795ZM13.1836 25.7368L12.8921 26.4278L13.1836 25.7368ZM10.4751 22.5603L11.1791 22.3017L10.4751 22.5603ZM21.5249 22.5603L22.2289 22.819V22.819L21.5249 22.5603ZM18.8164 25.7368L18.5248 25.0458H18.5248L18.8164 25.7368ZM9.74664 12.9291C9.70746 12.5167 9.34142 12.2142 8.92906 12.2534C8.5167 12.2925 8.21418 12.6586 8.25336 13.0709L9.74664 12.9291ZM23.7466 13.0709C23.7858 12.6586 23.4833 12.2925 23.0709 12.2534C22.6586 12.2142 22.2925 12.5167 22.2534 12.9291L23.7466 13.0709ZM24 11.75C24.4142 11.75 24.75 11.4142 24.75 11C24.75 10.5858 24.4142 10.25 24 10.25V11.75ZM8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75V10.25ZM20 11V11.75H20.75V11H20ZM12 11H11.25V11.75H12V11ZM21.7744 16.6761L21.512 18.5611L22.9977 18.7679L23.26 16.8829L21.7744 16.6761ZM10.488 18.5611L10.2256 16.6761L8.73996 16.8829L9.0023 18.7679L10.488 18.5611ZM16 25.25C14.4708 25.25 13.9254 25.2358 13.4752 25.0458L12.8921 26.4278C13.6891 26.7642 14.6056 26.75 16 26.75V25.25ZM9.0023 18.7679C9.282 20.7777 9.43406 21.9017 9.77109 22.819L11.1791 22.3017C10.9116 21.5736 10.7785 20.6488 10.488 18.5611L9.0023 18.7679ZM13.4752 25.0458C12.5528 24.6566 11.695 23.7058 11.1791 22.3017L9.77109 22.819C10.3857 24.4918 11.4821 25.8328 12.8921 26.4278L13.4752 25.0458ZM21.512 18.5611C21.2215 20.6488 21.0884 21.5736 20.8209 22.3017L22.2289 22.819C22.5659 21.9017 22.718 20.7777 22.9977 18.7679L21.512 18.5611ZM16 26.75C17.3944 26.75 18.3109 26.7642 19.1079 26.4278L18.5248 25.0458C18.0746 25.2358 17.5292 25.25 16 25.25V26.75ZM20.8209 22.3017C20.305 23.7058 19.4472 24.6566 18.5248 25.0458L19.1079 26.4278C20.5179 25.8328 21.6143 24.4918 22.2289 22.819L20.8209 22.3017ZM10.2256 16.6761C10.0035 15.08 9.83766 13.887 9.74664 12.9291L8.25336 13.0709C8.34819 14.069 8.51961 15.2995 8.73996 16.8829L10.2256 16.6761ZM23.26 16.8829C23.4804 15.2995 23.6518 14.069 23.7466 13.0709L22.2534 12.9291C22.1623 13.887 21.9965 15.08 21.7744 16.6761L23.26 16.8829ZM24 10.25H8V11.75H24V10.25ZM19.25 10V11H20.75V10H19.25ZM20 10.25H12V11.75H20V10.25ZM12.75 11V10H11.25V11H12.75ZM16 6.75C17.7949 6.75 19.25 8.20507 19.25 10H20.75C20.75 7.37665 18.6234 5.25 16 5.25V6.75ZM16 5.25C13.3766 5.25 11.25 7.37665 11.25 10H12.75C12.75 8.20507 14.2051 6.75 16 6.75V5.25Z" fill="#F51212" />
                                                                </svg>
                                                            </div>

                                                            <div className="items-center flex" onClick={() => { this.deleteKonten(item) }}>
                                                                <a className="text-black text-sm text-center text-[10px]">Delete</a>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        })}


                                    </div>


                                </div>
                            </div>
                        }
                        {/* <form>
            <div className="mb-6">
              <label for="fullname" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Nama Lengkap</label>
              <input type="text" id="fullname" value={this.state.nama} onChange={event => this.setState({ nama : event.target.value})} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Nama Lengkap" required />
            </div>
            <div className="mb-6">
              <label for="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Email Akun</label>
              <input type="email" id="email" value={this.state.data.email} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Email" required />
            </div>
            <div className="mb-6">
              <label for="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Kata Sandi</label>
              <input type="password" id="password" className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required />
            </div>
            <div className="mb-6">
              <label for="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">No. Handphone</label>
              <input type="text" id="phone" value={this.state.phone} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Phone Number" required onChange={event => this.setState({ phone : event.target.value})} />
            </div>
            <div className="mb-6">
              <label for="birthdate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Tanggal Lahir</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path></svg>
                </div>
                <input type="date" value={this.state.tglLahir} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date" />
              </div>
            </div>
            <div className="flex justify-end">
              <button onClick={this.simpanProfile} type="button" className="w-4/12 bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2">
                <div className="text-[#ffffff]">
                  Simpan
                </div>
              </button>
            </div>
            
          </form>
         */}
                    </div>

                }
            </div>
        );

    }
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <Etalase {...props} navigate={navigate} params={useParams()} />
}

export default WithNavigate;
